// extracted by mini-css-extract-plugin
export default {"wrapper":"MapLocation_wrapper__3ciWf","loading":"MapLocation_loading__QioeJ","rotate":"MapLocation_rotate__txYM6"};